export interface SofetchResponse {
  headers: Headers;
  body: ReadableStream<Uint8Array> | null;
  status: number;
  data: unknown;
}

export interface SofetchOptions extends Omit<RequestInit, 'body'> {
  body?: unknown;
  params?: Record<string, string>;
}

async function makeFetchHappen(
  endpoint: string,
  { body, params, method = 'GET', ...extraOptions }: SofetchOptions = {},
): Promise<SofetchResponse> {
  const config: RequestInit = {
    method,
    ...extraOptions,
  };
  if (body !== undefined) {
    config.body = JSON.stringify(body);
  }
  if (params) {
    const p = new URLSearchParams(params);
    endpoint += `?${p.toString()}`;
  }

  const resp = await fetch(endpoint, config);
  // We currently support parsing number responses or JSON
  // If we need other response types, the below code will need
  // to be modified.
  const bodyText = await resp.text();
  let data: unknown = null;
  try {
    data = JSON.parse(bodyText);
  } catch {
    /* swallow the json parse error */
  }
  if (resp.ok) {
    const { headers, body: responseBody, status } = resp;
    return { headers, body: responseBody, status, data };
  } else {
    return Promise.reject(resp);
  }
}

async function get(endpoint: string, config?: Omit<SofetchOptions, 'method'>): Promise<SofetchResponse> {
  return makeFetchHappen(endpoint, { ...config, method: 'GET' });
}

async function _delete(endpoint: string, config?: Omit<SofetchOptions, 'method'>): Promise<SofetchResponse> {
  return makeFetchHappen(endpoint, { ...config, method: 'DELETE' });
}

async function post(
  endpoint: string,
  body?: unknown,
  config?: Omit<SofetchOptions, 'method' | 'body'>,
): Promise<SofetchResponse> {
  return makeFetchHappen(endpoint, { ...config, method: 'POST', body });
}

export default { get, post, delete: _delete };
